export { default as ModularProductCard } from './ModularProductCard';
